/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.12",
    versionName: "0.2.0-nightly.2026.5.12",
    versionChannel: "nightly",
    buildDate: "2026-05-12T00:30:04.402Z",
    commitHash: "7253addc1794076a8ec0fcc7c2d6491849967756",
};
